import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { resetData, resetSettings, setProviders, setVisittype } from "../../redux/store";
import { useNavigate } from "react-router-dom";
import AppOptions from "general/overlayscreens/appoptions";
import PricingOptions from "general/overlayscreens/pricing";
import MainOptions from "./mainoptions";
import SubOptions from "./suboptions";
import api from '../../api/api';
import { Backdrop, CircularProgress, Button, Typography } from "@mui/material";

const PlanOptionWrap = () => {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [screen, setScreen] = useState(0);

  const handleClosePopup = () => {
    dispatch(resetSettings());
    dispatch(setProviders([]));
    dispatch(setVisittype([]));
    dispatch(resetData());
    localStorage.removeItem('mytab');
    sessionStorage.removeItem('auth');
    navigate('/auth');
    setPopupOpen(false);
  };

  const fetchPlans = async () => {
    try {
      setLoading(true);
      setError(false);
      const response = await api.get('/v1/subscription-plans');
      if (response.status === 200) {
        setData(response.data);
      } else {
        setData([]);
        setError(true);
      }
    } catch (err) {
      console.error(err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  return (
    <>
    <div className="w-full h-auto">



      {loading && (
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
          <CircularProgress color="inherit" size={40} />
        </Backdrop>
      )}

      {!loading && error && (
        <div className="flex flex-col items-center justify-center min-h-screen text-center p-4">
          <Typography variant="h6" color="error">
            Something went wrong. Please try again.
          </Typography>
          <Button variant="contained" onClick={fetchPlans} sx={{ mt: 2 }}>
            Retry
          </Button>
        </div>
      )}

      {!loading && !error && (
        <>
          {screen === 0 && <MainOptions data={data} setScreen={setScreen} />}
          <div className="w-full h-auto">
               {screen === 1 && <SubOptions data={data} setScreen={setScreen} />}
          </div>
       
        </>
      )}    </div>
    </>
  );
};

export default PlanOptionWrap;
